skrilla.directive('userExternalWallets', function (modalService) {
    return {
        templateUrl: 'directives/userExternalWallets/userExternalWallets.html',
        scope: {
            user: "="
        },
        controller: function ($scope, searchService, adminV2Service) {
            searchService.get("users/" + $scope.user.id + "/externalWallets").then(function(response) {
                $scope.wallets = response.data;
            });
            $scope.getCards = function() {
                searchService.get("users/" + $scope.user.id + "/creditCards").then(function (response) {
                    $scope.creditCards = response.data.map((it) => {
                        return {...it,
                                canVerify : it.verification && ['Pending', 'InProgress', 'Failed'].includes(it.verification.status)
                        }
                    })
                });
            }

            $scope.openV2 = function(cardId){
                adminV2Service.openV2(`/creditCards/${cardId}`);
            }

            $scope.getRefundStatus = function(card){
                if(card.depositStatus === "REFUNDED") return "YES";
                return "NO";
            }

            $scope.verify = function(card){
                modalService.confirm("Are you sure you would like to verify this user's credit card? This will allow them to withdraw. Check with Nick or he will get MAD! 😡😡😡", function(){
                    searchService.put("users/" + $scope.user.id + "/creditCards/" + card.verification.id  + "/verify", {}, "User Card Successfully verified!").then(function(response) {
                        $scope.getCards();
                    });
                });
            }
            $scope.getCards();
        }
    };
});
